// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-scatter';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm6.75 15.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm4-3a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm-6-1.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm6-4.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm6-2.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z' />
);

export const viewBox = '0 0 22 22';
